import React from 'react';
import {Styles} from '../../../../config/design/styles';
import FileManagerDialog from "./FileManagerDialog";
import {defaultVariables} from "../../../../config";
import Button from "@mui/material/Button";
import {CloseRounded, ImageTwoTone} from "@mui/icons-material";
import {withStyles} from "@mui/styles";
import {translateKey} from "../../../../config/values";
class SingleFileChooser extends React.Component {
    classes = this.props.classes;
    state={
        FileManagerPending: false,
        file: null,
    }
    async componentDidMount(){
        if(!!this.props.initial){
            await this.setState({
                file:this.props.initial
            })
            await this.fileChanges(this.props.initial);
        }
        await this.loadData()
    }
    async loadData(){
        await this.setState({
            file:this.props.initial
        })
        await this.fileChanges(this.props.initial);
    }
    toggleOperation= () => {
        this.setState({
            FileManagerPending:!this.state.FileManagerPending,
        })
    }

    setData = async (file) => {
        await this.setState({
            file
        })
        await this.toggleOperation();
        await this.fileChanges(file);
    }
    async removeDataSheet(){
        await this.setState({
            file: null
        });
        this.fileChanges(null);
    }
    async fileChanges(file){
        await this.props.onChange(file)
    }
    render(){
        let {FileManagerPending,file} = this.state;
        let{title,required,disabled,print,simple,primary,style,width,image_size} = this.props;

        return(
            <div style={{width: !!width ? width : "100%"}}>
                {
                    (!!file && !simple) &&
                    <div className={this.classes.singleImageHolder} style={style}>
                        <a  rel="noopener noreferrer"  className={this.classes.primaryLink} target="_blank" href={`${defaultVariables.uploads}/FileManager/${file.name}.${file.extension}`}>
                            <img src={`${defaultVariables.uploads}/FileManager/${file.name}_${!!image_size ? image_size : "small"}.${file.extension}`} className="fileChooser-image"/>
                        </a>
                        {
                            !disabled &&
                            <Button
                                startIcon={<CloseRounded />}
                                size="small"
                                variant="contained"
                                onClick={() => this.removeDataSheet()}
                            >
                                {translateKey('removeImage')}
                            </Button>
                        }
                    </div>
                }
                {
                    !disabled && !file &&
                    <Button
                        startIcon={<ImageTwoTone />}
                        color="secondary"
                        variant="outlined"
                        className={!simple ? this.classes.addImageBtn : ''}
                        onClick={this.toggleOperation.bind(this)}
                        style={{aspectRatio: image_size === "s_thumb" ? 2 : 1 }}
                    >

                        {!!this.props.title ? this.props.title : translateKey('addImage')}
                    </Button>
                }
                {
                    FileManagerPending ?
                        <FileManagerDialog
                            preview={this.props.preview}
                            selection
                            logo={this.props.logo}
                            single={true}
                            cancleOperation={this.toggleOperation}
                            setData={this.setData}
                            defined_width={this.props.defined_width}
                            defined_height={this.props.defined_height}
                        /> : null
                }
            </div>
        )

    }
}
export default withStyles(Styles)(SingleFileChooser);